import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';

export const environment = {
  production: true,
  name: 'test',
  isStation: true,
  apis: {
    appInsights: {
      instrumentationKey: 'd42aa11d-d4ad-4a4b-ac19-430b759431ca', // appinsightstest-nim-client-station
    },
    azure: {
      correlationTokenName: 'abc-correlation-token',
      subscriptionKeyHeaderName: 'Ocp-Apim-Subscription-Key',
      subscriptionKey: '9b624b2318b7444d8fb13bfd48a2b41b',
    },
    diagnosisCode: {
      endpointUrl: '',
      subscriptionKeyHeaderName: 'Ocp-Apim-Subscription-Key',
      subscriptionKey: '11637329ff1c481d877fe4dd11a1fe2e',
    },
    entitlements: {},
    emrintegration: {},
    e2e: {
      endpointUrl: 'https://services.test.hdp.amerisourcebergen.com/e2e',
    },
    formulary: {},
    identity: {},
    inventory: {},
    lookup: {},
    party: {},
    purchaseorder: {},
    patient: {},
    physician: {},
    stationmanagement: {},
    printing: {
      endpointUrl: 'https://services.test.hdp.amerisourcebergen.com/Printing',
    },
    configuration: {
      endpointUrl: 'https://services.test.hdp.amerisourcebergen.com/configuration',
    },
    pricing: {
      endpointUrl: 'https://services.test.hdp.amerisourcebergen.com/Pricing',
    },
  },
  msalConfig: {
    interactionType: InteractionType.Popup,
    auth: {
      clientId: '4cc6def6-c5a4-4aab-93b8-d9cbad4cb1f0',
      navigateToLoginRequestUrl: false,
      redirectUri: '/auth',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      loggingOptions: {
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false,
      },
    },
  },
  apiConfig: {
    scopes: ['4cc6def6-c5a4-4aab-93b8-d9cbad4cb1f0'],
    uri: 'https://services.test.hdp.amerisourcebergen.com',
    anonymousEndpoints: [],
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1A_local_signin',
      resetPassword: 'B2C_1A_local_signin',
      editProfile: 'B2C_1A_local_signin',
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://PSGCustomerTest.b2clogin.com/PSGCustomerTest.onmicrosoft.com/B2C_1A_local_signin',
      },
      resetPassword: {
        authority: 'https://PSGCustomerTest.b2clogin.com/PSGCustomerTest.onmicrosoft.com/B2C_1A_local_signin',
      },
      editProfile: {
        authority: 'https://PSGCustomerTest.b2clogin.com/PSGCustomerTest.onmicrosoft.com/B2C_1A_local_signin',
      },
    },
    authorityDomain: 'PSGCustomerTest.b2clogin.com',
  },
  cmsUrl: 'https://cms.nucleusinventory.com/cms/production/stationmvp/',
};
